<template>
  <div class="page-title-box">
    <div class="row align-items-center">
      <div class="col-sm-6">
        <h4 class="page-title">Minhas Turmas</h4>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-right">
          <li class="breadcrumb-item"><a href="#">Inicio</a></li>
          <li class="breadcrumb-item">Turmas</li>
          <li class="breadcrumb-item active">Minhas Turmas</li>
        </ol>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <span
          class="alert-danger message-alert"
          style="
            width: 100%;
            padding: 5px;
            border-radius: 4pt;
            font-size: 12pt;
            font-weight: bold;
          "
          v-if="error_message !== ''"
        >
          {{ error_message }}
        </span>
      </div>
    </div>
    <!-- end row -->
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="d-flex justify-content-end">
        <!-- <div class="col-sm-2 mb-2">
          <select
            class="form-control"
            style="border-radius: 16px"
            @change="onChangeYearFindClassmate"
            v-model="semester"
          >
            <option disabled selected>Selecionar semestre</option>
            <option value="1" v-for="s in semester" :key="s.id">
              {{ s.semester_name }}
            </option>
          </select>
        </div> -->
        <div class="col-lg-3 mb-2">
          <select
            class="form-control"
            style="border-radius: 16px"
            @change="onChangeYearFindClassmate"
            v-model="assessment_year"
          >
            <option value="">Selecionar avaliação</option>
            <option
              :value="y"
              v-for="(y, index) in studentEntryYear"
              :key="index"
            >
              {{ y }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-8 col-lg-12 col-md-12">
      <div
        class="card"
        v-if="classmates.length > 0"
        v-for="(c, index) in classmates"
        :key="index"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="card-body mb-2">
              <h4 class="text-muted">
                1 Ano {{ c.classmate.level.name }} em
                {{ c.classmate.course.name }}
              </h4>
              <hr />
              <br />
              <ul class="list-unstyled">
                <li class="mb-2">
                  <h4 class="">
                    <i class="mdi mdi-chair-school text-primary"></i>
                    {{ c.classmate.name }}
                  </h4>
                  <small class="text-center"
                    >{{ c.classmate.entry_year }}, Semstre
                    {{ c.classmate.semester.semester_name }},
                    {{ c.classmate.level.name }}
                  </small>
                </li>
                <li class="mb-2">
                  <strong class="">{{ c.subject?.name }} </strong
                  ><span class="text-white"></span>
                </li>

                <li class="mb-2">
                  <Button
                    type="danger"
                    class="btn btn-primary btn-md"
                    :loadingEvaluate="loadingEvaluate"
                    @click="exportDataToPdf(c.subject_id, c.classmate.id)"
                  >
                    Exportar para pdf
                    <i class="mdi mdi-file-pdf text-danger"></i>
                  </Button>

                  <!-- <Button
                    type="success"
                    @click="exportDataToExcel(c.subject.id, c.classmate.id)"
                    class="btn btn-success btn-md ml-2"
                  >
                    <i class="fa fa-file-excel-o"> </i>
                    Exportar para excel
                  </Button> -->
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div
        class="card"
        v-if="classmateByYear.length > 0"
        v-for="(c, index) in classmateByYear"
        :key="index"
      >
        <div class="row">
          <div class="col-md-12">
            <!-- <div class="card-header">
              <h3 class="card-title">
                Perfil pessoal
              </h3>
            </div> -->
            <div class="card-body mb-2">
              <!-- <img src="" class="img-card img-fluid" alt=""> -->
              <!-- <button class="btn btn-md btn-primary btn-block">carreagar foto de perfil</button> -->
              <h4 class="text-muted">
                1 Ano {{ c.classmate.level.name }} em
                {{ c.classmate.course.name }}
              </h4>
              <hr />
              <br />
              <ul class="list-unstyled">
                <li class="mb-2">
                  <h4 class="">
                    <i class="mdi mdi-chair-school text-primary"></i>
                    {{ c.classmate.name }}
                    <!-- <span style="visibility: hidden;">
                      {{getFormulaByclassmate(c.classmate.id, c.subject.id)}}
                    
                    </span> -->
                  </h4>
                  <small class="text-center"
                    >{{ c.classmate.entry_year }}, Semstre
                    {{ c.classmate.semester.semester_name }},
                    {{ c.classmate.level.name }}
                  </small>
                </li>
                <li class="mb-2">
                  <strong class="">{{ c.subject?.name }} </strong
                  ><span class="text-white"></span>
                </li>

                <li class="mb-2">
                  <Button
                    type="danger"
                    class="btn btn-primary btn-md"
                    :loadingEvaluate="loadingEvaluate"
                    @click="exportDataToPdf(c.subject.id, c.classmate.id)"
                  >
                    Exportar para pdf
                    <i class="mdi mdi-file-pdf text-danger"></i>
                  </Button>
                  <!-- :to="{
                      name: 'assessment_studant',
                      params: {
                        subject_id: c.subject.id,
                        classmate_id: c.classmate.id,
                      },
                    }" -->
                  <!-- <Button
                    type="success"
                    @click="exportDataToExcel(c.subject.id, c.classmate.id)"
                    class="btn btn-success btn-md ml-2"
                  >
                    Avaliar estudante
                  </Button> -->
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Loading :loadingData="loading"></Loading>
</template>
  
  <script setup>
import { onMounted, ref } from "vue";
import TeacherDashStoreModule from "@/pages/TeacherDashboard/TeacherDashStoreModule";
import { useRoute } from "vue-router";
import toastr from "toastr";
import { useStore } from "vuex";
import Loading from "@/components/Loading.vue";

const studentEntryYear = ref([]);

const classmates = ref([]);
const classmateByYear = ref([]);
const isClose = ref(false);
var countTrabPercent = ref(1);
var countTestPercent = ref(1);
const assessment_type = ref([]);
const error_message = ref("");
const subject_id = ref();
const loading = ref(false);
const loadingEvaluate = ref(false);
const semester = ref([]);
const classmate_id = ref();
const headerTitle = ref([]);
onMounted(() => {
  getTurmas();
  teacherEntryYearTillToday();
});

async function exportDataToPdf(subject_id, classmate_id) {
  try {
    loading.value = true;
    const [StudentResponse] = await Promise.all([
      TeacherDashStoreModule.actions.getStudentByClassMatesExport(
        classmate_id,
        subject_id
      ),
    ]);

    window.open(
      "https://mvp.isupec.ac.mz/mvp/Api/storage/app/public/" + StudentResponse,
      "_blank"
    );
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

// async function exportDataToExcel(subject_id, classmate_id) {
//   try {
//     loading.value = true;

//     const [StudentResponse, assesmentType, getAssessmentExams] =
//       await Promise.all([
//         TeacherDashStoreModule.actions.getStudentByClassMates(classmate_id),
//         TeacherDashStoreModule.actions.getFormulaByClass(
//           classmate_id,
//           subject_id
//         ),
//         TeacherDashStoreModule.actions.getAssessmentExams(),
//       ]);
//     headerTitle.value = [
//       "fullName",
//       ...assesmentType.map((type) => type.assessment_type),
//     ]; //Titulo das colunas
//     let dataEvaluation = StudentResponse.data.map((student) => {
//       // criar o objecto base para cada estudantes

//       let dataEval = {
//         id: student.id,
//         fullName: student.person.fullName,
//       };

//       assesmentType.forEach((type) => {
//         let result = student.assessment_result.find(
//           (item) =>
//             item.assesment_type === type.assessment_type &&
//             item.subject_id === parseInt(subject_id)
//         );
//         dataEval[type.assessment_type] = result
//           ? result.assessment_value
//           : null;
//       });
//       // dataEvaluation.push(dataEval);
//       return dataEval;
//     });
//     console.log(
//       dataEvaluation.map((student) =>
//         headerTitle.value.map((key) => console.log(key))
//       )
//     );

//     let worksheetData = [
//       headerTitle.value,
//       ...dataEvaluation.map((student) =>
//         headerTitle.value.map((key) => student[key] ?? "")
//       ),
//     ];
//     const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
//     // ajustar a largura das colunas
//     worksheet["!cols"] = headerTitle.value.map(() => ({ wch: 20 }));
//     // aplicar estilo de negrito ao cabecalho
//     const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);
//     for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
//       const cellRef = XLSX.utils.encode_cell({ r: 0, c: col });
//       if (!worksheet[cellRef]) continue;
//       worksheet[cellRef].s = {
//         font: { bold: true, color: { rgb: "FFFFFF" } },
//         fill: { fgColor: { rgb: "000000" } },
//       };
//     }
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Notas");

//     const excelBuffer = XLSX.write(workbook, {
//       bookType: "xlsx",
//       type: "array",
//     });
//     const blob = new Blob([excelBuffer], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     });

//     saveAs(blob, "Notas.xlsx");
//   } catch (error) {
//     console.log(error);
//   } finally {
//     loading.value = false;
//   }
// }

function inputPercentage(index, type) {
  assessment_type.value.push({
    id: index,
    assessment_type: type,
    percentage: valor,
  });
}

function SelectedAssissments(evt) {
  if (evt.target.value == "MINI-TESTE") {
    if (miniTeste.value.length > 0) {
      toastr.info(`o ${evt.target.value} ja existe`);
    } else {
      miniTeste.value.push({
        id: "",
        assessment_type: evt.target.value + "-" + countTestPercent.value,
        percentage: "",
      });
    }
  } else if (evt.target.value == "TRABALHO-PESQUISA") {
    if (Jobs.value.length > 0) {
      toastr.info(`o ${evt.target.value} ja existe`);
    } else {
      Jobs.value.push({
        id: "",
        assessment_type: evt.target.value + "-" + countJobs.value,

        percentage: "",
      });
    }
  } else {
    if (Teste.value.length > 0) {
      toastr.info(`o ${evt.target.value} ja existe`);
    } else {
      Teste.value.push({
        id: "",
        assessment_type: evt.target.value + "-" + countTest.value,
        percentage: "",
      });
    }
  }
}

async function getTurmas() {
  try {
    loading.value = true;
    const profile = JSON.parse(localStorage.getItem("myProfile"));

    const classmateResponse = await TeacherDashStoreModule.actions.getClassmate(
      profile.id
    );

    classmates.value = classmateResponse.data;
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

function addWeightForAssessments(subject_idd, classmate_idd) {
  isClose.value = true;

  subject_id.value = subject_idd;
  classmate_id.value = classmate_idd;
  // findAssessmentValue(subject_id, classmate_id);
}

function closeModal() {
  isClose.value = false;
}

async function handleSubmitWeight() {
  try {
    loading.value = true;

    var assessment_type = [
      ...miniTeste.value,
      ...Teste.value,
      ...Jobs.value,
      ...extraAvaliation.value,
    ];

    console.log(assessment_type);

    const resp = await TeacherDashStoreModule.actions.submitData(
      assessment_type,
      classmate_id.value,
      subject_id.value
    );

    if (resp.data.status === true) {
      error_message.value = null;
      closeModal();
      // error_message.value = resp.response.data.error_message;
      toastr.success(resp.data.message);
    }
  } catch (error) {
    console.log(error);
    if (typeof error.response != "undefined") {
      Object.keys(error.response.data.errors).forEach((key) => {
        toastr.info(key, error.response.data.errors[key]);
      });
    }
  } finally {
    loading.value = false;
  }
}

async function getFormula() {
  const resp = await TeacherDashStoreModule.actions.getAllFormulas();
  classmateFormula.value = resp.data;
  console.log(resp);
}

async function removeDataTest(id, index) {
  const resp = await TeacherDashStoreModule.actions.DeleteDataTest(id);

  classmateFormula.value.splice(index, 1);
  console.log(resp);
}

async function editDataTest(id, index) {
  isEdit.value = true;
  classmateFormula.value.forEach((element) => {
    if (element.id === id) {
      testDataEdit.value.assessment_type = element.assessment_type;
      testDataEdit.value.percentage = element.percentage;
      testDataEdit.value.id = element.id;
    }
  });
}

async function updateTestData(id) {
  loading.value = true;

  const resp = await TeacherDashStoreModule.actions.updateFormula(
    testDataEdit.value,
    id
  );
  if (resp.data == 1) {
    getFormula();
    isEdit.value = false;
  }
  loading.value = false;
}

function addMoreMiniTeste() {
  countTestPercent.value += 1;
  miniTeste.value.push({
    assessment_type: "MINI-TESTE-" + countTestPercent.value,
    percentage: "",
  });
}
var countTest = ref(1);
function addMoreTeste() {
  countTest.value += 1;
  Teste.value.push({
    assessment_type: "TESTE-" + countTest.value,
    percentage: "",
  });
}
var countJobs = ref(1);
function addMoreJobs() {
  countJobs.value += 1;
  Jobs.value.push({
    assessment_type: "TRABALHO-PESQUISA-" + countJobs.value,
    percentage: "",
  });
}

function removerFieldsMiniTeste(index) {
  miniTeste.value.splice(index, 1);
}

function removerFieldsTeste(index) {
  Teste.value.splice(index, 1);
}

function removerFieldsJobs(index) {
  Jobs.value.splice(index, 1);
}

function remove(index) {
  //  datatTeste.value.testData.splice(index, 1);
  assessment_home_works.value.splice(index, 1);
  countTestPercent.value -= 1;
}

function addPercenteTrabalho() {
  countTrabPercent.value += 1;
  datatTeste.value.trabalho.push({ percentegemTrabalho: "" });
}

function removeTrabalho(index) {
  assessment_home_works.value.splice(index, 1);
  countTrabPercent.value -= 1;
}

// resposavel por retornar todos os anos do professor apartir do ano de entrada/alocacao
async function teacherEntryYearTillToday() {
  try {
    loading.value = true;

    const profile = JSON.parse(localStorage.getItem("myProfile"));

    const entryYearResponse =
      await TeacherDashStoreModule.actions.getFirstYearTeacherAlocated(
        profile.id
      );

    const currentYear = new Date().getFullYear();
    const entryYear = new Date(entryYearResponse.data.created_at).getFullYear();

    for (let year = currentYear; year >= entryYear; year--) {
      studentEntryYear.value.push(year);
    }
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

async function onChangeYearFindClassmate(event) {
  try {
    loading.value = true;
    classmates.value = [];
    const profile = JSON.parse(localStorage.getItem("myProfile"));

    const classmateByYearResponse =
      await TeacherDashStoreModule.actions.findClassmateByYear(
        event.target.value,
        profile.id
      );
    classmateByYear.value = classmateByYearResponse.data.classmate;

    // semester.value = classmateByYearResponse.data.semesters;
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}
</script>
  